/**
 * 初期表示で実行させる処理
 */
export default class Init {
	constructor() {
		this.bodyAddClass();
	}
	bodyAddClass() {
		let ua = window.navigator.userAgent.toLowerCase();
		if (ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1) {
			$('body').addClass('is-ie');
		} else if (ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document) {
			$('body').addClass('is-ipad');
		}
	}
}
